import {configParamsModule} from "../../configParamsModule";
import {
    LoadingService,
    MessagesModal,
    RemoteExceptionHandler
} from "../../../../bower_components/front-end-web-commons";
import {PermissionGroupDetailsService} from "./permissionGroupDetailsService";

class PermissionGroupDetailsController {
    permissionGroupId: number

    constructor(private permissionGroupDetailsService: PermissionGroupDetailsService,
                private loadingService: LoadingService,
                private remoteExceptionHandler: RemoteExceptionHandler,
                private messagesModal: MessagesModal,
                private permissionGroup: any) {

        this.permissionGroupId = permissionGroup.id
    }

}

configParamsModule.controller("permissionGroupDetailsController", PermissionGroupDetailsController);